import { css, type Theme } from "@emotion/react";

export const form = (theme: Theme) => css`
  display: flex;
  flex-direction: column;
  gap: ${theme.ds5.spacing.gap.medium};
  width: 500px;
  max-width: 100%;
`;

export const orSectionWrapper = css`
  text-align: center;
  width: 100%;
`;

export const tosRow = (theme: Theme) => css`
  margin-top: ${theme.ds5.spacing.gap.small};
`;

export const tosError = (theme: Theme) => css`
  display: flex;
  align-items: center;
  gap: ${theme.ds5.spacing.gap.xsmall};
  margin-top: ${theme.ds5.spacing.gap.xsmall};
  margin-left: 28px;
`;

export const tosErrorText = (theme: Theme) => css`
  color: ${theme.ds5.critical.text};
`;

export const submit = (theme: Theme) => css`
  margin-top: ${theme.ds5.spacing.gap.small};
`;

export const ssoButtons = css`
  width: 100%;
`;

export const srOnly = css`
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
`;
